export default __webpack_public_path__ + "static/media/stake_btn.0412b2b8.svg";